import React, { useEffect, useState } from 'react';
import FormSelect from '../../common/FormSelect/FormSelect';
import FormTextarea from '../../common/FormTextarea/FormTextarea';
import {
  STUDENT_INACTIVATION_REASON_OPTIONS,
  type StudentInactivationReason,
} from '../../../constants/studentInactivationReason';
import { useEscapeToClose } from '../../../hooks/useEscapeToClose';
import styles from '../PaymentDetails/CreateSubscriptionModal.module.css';

interface StudentInactivationReasonModalProps {
  open: boolean;
  studentName: string | null;
  onProceed: (reason: StudentInactivationReason, observation: string | null) => void;
  onCancel: () => void;
}

const StudentInactivationReasonModal: React.FC<StudentInactivationReasonModalProps> = ({
  open,
  studentName,
  onProceed,
  onCancel,
}) => {
  const [reason, setReason] = useState('');
  const [observation, setObservation] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) {
      setReason('');
      setObservation('');
      setError(null);
    }
  }, [open]);

  useEscapeToClose(onCancel, open);

  if (!open) return null;

  const handleProceed = () => {
    if (!reason) {
      setError('Selecione o motivo da inativação.');
      return;
    }
    onProceed(reason as StudentInactivationReason, observation.trim() || null);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()} style={{ width: 480, alignItems: 'stretch' }}>
        <div className={styles['icon-circle']} style={{ alignSelf: 'center' }}>
          <span className="material-symbols-outlined">person_off</span>
        </div>

        <h3 className={styles.title}>Inativar aluna</h3>
        <p className={styles.message}>
          Selecione o motivo da inativação
          {studentName ? ` de ${studentName}` : ''}.
        </p>

        <FormSelect
          id="student-inactivation-reason"
          label="Motivo da inativação"
          name="inactivationReason"
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (error) setError(null);
          }}
          options={[...STUDENT_INACTIVATION_REASON_OPTIONS]}
          placeholder="Selecione o motivo"
          error={error ?? undefined}
          required
          containerClassName={styles['select-wrap']}
        />

        <FormTextarea
          id="student-inactivation-observation"
          label="Observação"
          name="inactivationObservation"
          value={observation}
          onChange={(event) => setObservation(event.target.value)}
          placeholder="Escreva uma observação, se quiser"
          rows={3}
          containerClassName={styles['select-wrap']}
        />

        <div className={styles.actions}>
          <button
            type="button"
            className={`${styles.btn} ${styles['btn-cancel']}`}
            onClick={onCancel}
          >
            Voltar
          </button>
          <button
            type="button"
            className={`${styles.btn} ${styles['btn-confirm']}`}
            onClick={handleProceed}
            style={{ backgroundColor: 'var(--color-solid-danger)' }}
          >
            Inativar
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentInactivationReasonModal;
